export const ItemTypes = {
    PRODUCT: 'Product'
}
